export function getOnlineOrOffline(isOnline: boolean): string {
    return isOnline ? "Онлайн" : "Лично"
}
